// BUBBLE — chat-style transcript. Questions render as accent-colored chat
// bubbles on the right, answers as replies on the left with a "?" avatar.
// No toggles — everything is visible; staggered entrance reveal only.
//  - bubble radius: max(14px, 1.6x base) via CSS max()
function itemHtml(ctx, it, i) {
    return `<div class="fq-msg"${ctx.reveal(i)}>
  <div class="fq-qb">${it.q}</div>
  <div class="fq-arow">
    <span class="fq-avatar" aria-hidden="true">?</span>
    <div class="fq-a">${it.aHtml}</div>
  </div>
</div>`;
}
const bubble = {
    id: 'bubble',
    name: 'Bubble',
    tag: 'Chat-style',
    styleTag: 'Playful',
    description: 'Questions as chat bubbles, answers as replies. The friendliest way to present an FAQ \u2014 great for consumer products and anything with personality. Entrance animation included.',
    layout: 'chat',
    defaultAccent: '#0e8f7e',
    darkDefault: false,
    catSupport: 'none',
    features: ['reveal'],
    render(ctx) {
        const bubbleRadius = `max(14px, calc(${ctx.v.radius} * 1.6))`;
        const html = `<div class="fq-wrap">
  <div class="fq-head">
    <h2 class="fq-title">${ctx.title}</h2>
    ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  </div>
  <div class="fq-thread">
${ctx.items.map((it, i) => itemHtml(ctx, it, i)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:620px;margin:0 auto}
.FQM .fq-head{text-align:center;margin-bottom:30px}
.FQM .fq-title{margin:0 0 8px;font-family:${ctx.v.head};font-size:32px;font-weight:650;line-height:1.12;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-thread{display:flex;flex-direction:column;gap:22px}
.FQM .fq-msg{display:flex;flex-direction:column;gap:10px}
.FQM .fq-qb{align-self:flex-end;max-width:82%;padding:12px 18px;background:${ctx.v.accent};color:#ffffff;font-size:15.5px;font-weight:500;line-height:1.45;border-radius:${bubbleRadius};border-bottom-right-radius:6px}
.FQM .fq-arow{align-self:flex-start;display:flex;gap:10px;max-width:88%}
.FQM .fq-avatar{flex:0 0 auto;display:grid;place-items:center;width:30px;height:30px;margin-top:2px;border-radius:999px;background:${ctx.v.soft};color:${ctx.v.accent};font-size:13px;font-weight:700;font-family:${ctx.v.head}}
.FQM .fq-a{padding:12px 18px;background:${ctx.v.card};border:1px solid ${ctx.v.border};color:${ctx.v.sub};font-size:15px;line-height:1.6;border-radius:${bubbleRadius};border-top-left-radius:6px}
`;
        return { html, css };
    },
};
export default bubble;
